module.exports = __webpack_public_path__ + "static/img/sustainable-solutions-rnd-digital-services-factory.efef761.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sustainable/sustainable-solutions-rnd-digital-services-factory.jpg
// module id = iSUg
// module chunks = 0